export class AccAllowanceSubCategoryResultDto {
    allowanceCategoryId: string;
    allowanceSubCategoryId: string;
    allowanceSubCategoryName: string;
}
